import { ColumnMiddle } from 'layout/Components/Column'
import Loader from 'layout/Components/SideBar/Loader'
import React, { useEffect, useState } from 'react'
import { useToggleSidebar } from 'state/app/hooks'
import {
  useActiveTournamentId,
  useDetectTournament,
  useTournamentDetails,
  useTournamentList,
} from 'state/tournament/hooks'
import styled from 'styled-components'
import Box from 'UIKit/Box/Box'
import TransText from 'UIKit/Text/TransText'
import EligibleGames from './components/EligibleGames'
import EligibleGameLoader from './components/EligibleGames/EligibleGameLoader'
import ProviderEligbleGames from './components/EligibleGames/ProviderEligbleGames'
import LeaderBoard from './components/LeaderBoard'
import LeaderBoardLoader from './components/LeaderBoard/LeaderBoardLoader'
import { ProviderTournamentLeaderBoard } from './components/LeaderBoard/ProviderTournamentLeaderBoard'
import TournamentEmpty from './components/TournamentEmpty'
import TournamentRules from './components/TournamentRules'
import TournamentRulesLoader from './components/TournamentRules/TournamentRulesLoader'
import TournamentSlides from './components/TournamentSlides'

const ProviderTournament = () => {
  const { availableTournaments } = useTournamentList()
  const activeTournamentId = useActiveTournamentId()
  const providerTournament = availableTournaments.find((tournament) => tournament.id === activeTournamentId)
  const { closeSidebar } = useToggleSidebar()

  return (
    <>
      <TournamentRules rulesDescription={providerTournament?.details?.rules} />
      <ProviderTournamentLeaderBoard />
      <ProviderEligbleGames
        gameCollectionId={providerTournament?.details?.collectionGameId || null}
        onGameSelected={async () => {
          closeSidebar()
        }}
      />
    </>
  )
}

const PlatformTournament = () => {
  const { tournamentDetails: activeTournament } = useTournamentDetails()
  const { closeSidebar } = useToggleSidebar()

  return (
    <>
      {activeTournament ? (
        <>
          <TournamentRules rulesDescription={activeTournament?.rules} />
          <LeaderBoard tournamentDetails={activeTournament || null} />
          <EligibleGames
            gameCollectionId={activeTournament?.collectionGameId || null}
            onGameSelected={async () => {
              closeSidebar()
            }}
          />
        </>
      ) : (
        <>
          <TournamentRulesLoader />
          <LeaderBoardLoader />
          <EligibleGameLoader />
        </>
      )}
    </>
  )
}

const TournamentPage: React.FC = React.memo(() => {
  const { availableTournaments } = useTournamentList()
  const { isProviderTournament } = useDetectTournament()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 1500)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <>
      {isLoading && <Loader isLoaded={!isLoading} />}
      <Container $loading={isLoading} p="12px" maxWidth={['unset', 'unset', 'unset', '350px']}>
        {availableTournaments.length ? (
          <>
            <TournamentSlides />
            {isProviderTournament ? <ProviderTournament /> : <PlatformTournament />}
          </>
        ) : (
          <TournamentEmpty />
        )}
      </Container>
    </>
  )
})

const Container = styled(ColumnMiddle)<{ $loading: boolean }>`
  gap: 12px;
  overflow-x: hidden;

  opacity: ${({ $loading }) => ($loading ? '0' : '1')};
`

export const CardSection = styled(Box)`
  background: ${({ theme }) => theme.colors.backgroundAlt5};
  border-radius: 14px;
  padding: 12px;
`

export const CardTitle = styled(TransText)`
  font-weight: 700;
  font-size: 14px;
  line-height: normal;
  letter-spacing: -0.32px;
  color: ${({ theme }) => theme.colors.textTertiary};
`

export default TournamentPage
